import React from 'react';
function NotFound() {
    return (
        <div className="jumbotron  d-flex align-items-center justify-content-center h-100">
            <h1>Page not found</h1>
        </div>
        
    )
}
export default NotFound;